import { createTheme } from '@mui/material/styles'

export const theme = createTheme({
  spacing: 8,
  palette: {
    mode: 'light',
    primary: {
      main: '#2C063F',
    },
    secondary: {
      main: '#475467',
    },
  },
  typography: {
    fontFamily: 'Inter',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiTypography: {
    styleOverrides: {
      root: {
        color: '#344054',
      },
    },
  },
  },
})
